import moment from "moment";

export default {
    filter(events, filters) {
        for (const key in filters) {
            let value = filters[key];
            if (value !== null)
                events = this[key](events, value)
        }

        return events
    },
    province(events, provinceId) {
        return events.filter(event => {
            return event.province.id === provinceId
        })
    },

    month(events, month) {
        return events.filter(event => {
            return moment(event.datetime).month() === month
        })
    },

    sort(events, type) {
        if(!events)
            return events

        if (type === 'asc')
            return events.sort(this.asc)

        return events.sort(this.desc)
    },

    asc(a, b) {
        if (a.datetime < b.datetime)
            return -1;

        if (a.datetime > b.datetime)
            return 1;

        return 0;
    },

    desc(a, b) {
        if (a.datetime < b.datetime)
            return 1;

        if (a.datetime > b.datetime)
            return -1;

        return 0;
    }
}
